import React from "react";
import { MdClose } from "react-icons/md";

export default function RestoreModal({ isOpen, onClose, onConfirm, user, isRestoring }) {
    if (!isOpen) return null;

    return (
        <div className="modal modal-open">
            <div className="modal-box relative bg-white">
                <div className="flex items-center justify-between">
                    <h2 className="text-lg font-semibold">Restore User</h2>
                    <MdClose onClick={onClose} size={18} className="cursor-pointer" />
                </div>

                {/* Icon */}
                <div className="flex justify-center my-6">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                        <svg
                            className="w-8 h-8 text-green-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                        </svg>
                    </div>
                </div>

                {/* Content */}
                <p className="capitalize text-md mb-2 text-center font-bold text-xl">
                    Restore this user?
                </p>
                <p className="text-sm text-gray-600 mb-4 text-center">
                    {user?.name} ({user?.email}) will be restored and can log in again.
                </p>

                <div className="flex justify-center gap-10 mt-6">
                    <button
                        onClick={onClose}
                        disabled={isRestoring}
                        className="btn btn-outline btn-sm border border-[#EBEBEB] min-w-30 rounded-full min-h-[40px] hover:opacity-50 hover:bg-white hover:shadow-none hover:text-black"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isRestoring}
                        className="btn bg-[#4CAF50] btn-sm min-w-30 rounded-full shadow-none text-white p-2.5 min-h-[40px] hover:opacity-50"
                    >
                        {isRestoring ? "Restoring..." : "Yes, Restore"}
                    </button>
                </div>
            </div>
        </div>
    );
}
